/* MD — store-wide slider smoothing.
   Any element that scrolls horizontally gets the same behaviour: no mandatory
   snap fighting the finger, momentum scrolling, and a soft settle on release.
   Runs on every page and again whenever new markup appears. */
(function () {
  var SEEN = 'mdSmoothed';

  function tune(el) {
    if (!el || el.dataset[SEEN]) return;
    var cs = window.getComputedStyle(el);
    var overflowX = cs.overflowX;
    if (overflowX !== 'auto' && overflowX !== 'scroll') return;
    if (el.scrollWidth <= el.clientWidth + 2) return;

    el.dataset[SEEN] = '1';
    el.style.setProperty('scroll-snap-type', 'x proximity', 'important');
    el.style.setProperty('scroll-behavior', 'auto', 'important');
    el.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    el.style.setProperty('overscroll-behavior-x', 'contain', 'important');

    Array.prototype.forEach.call(el.children, function (child) {
      child.style.setProperty('scroll-snap-stop', 'normal', 'important');
    });
  }

  function scan() {
    var nodes = document.querySelectorAll('main div, main ul, main ol, main section, main nav');
    for (var i = 0; i < nodes.length; i++) tune(nodes[i]);
  }

  function run() {
    scan();
    [200, 600, 1200, 2000, 3200].forEach(function (ms) { setTimeout(scan, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  window.addEventListener('load', scan);
  window.addEventListener('resize', scan);
  document.addEventListener('shopify:section:load', run);

  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; scan(); }, 300);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
